"use client";

import { Suspense, useState, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n, { initI18next } from '@/src/i18n/i18next';

// Component that waits for i18n initialization
function I18nReady({ children }: { children: React.ReactNode }) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    initI18next().then(() => {
      setIsReady(true);
    });
  }, []);

  if (!isReady) {
    return null;
  }

  return <>{children}</>;
}

export function I18nProvider({ children }: { children: React.ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <I18nReady>
        {children}
      </I18nReady>
    </I18nextProvider>
  );
}
